import React, { useState, useMemo } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import './Gratuity.css';

const Gratuity = () => {
  const [salary, setSalary] = useState(50000);
  const [years, setYears] = useState(5);

  const gratuityAmount = useMemo(() => {
    // Formula: (Basic + DA) * 15 / 26 * Years of service
    const amount = (salary * 15 * years) / 26;
    return Math.round(amount);
  }, [salary, years]);

  const chartData = [
    { name: 'Gratuity', value: gratuityAmount, color: '#ae0a0b' }
  ];

  const formatCurrency = (num) => {
    return '₹ ' + num.toLocaleString('en-IN');
  };

  const getSliderStyle = (val, min, max) => {
    const percentage = ((val - min) / (max - min)) * 100;
    return {
      background: `linear-gradient(to right, #ae0a0b ${percentage}%, #e5e7eb ${percentage}%)`
    };
  };

  return (
    <div className="gratuity-calculator-content">
      {/* Left Side: Inputs */}
      <div className="gratuity-input-section">
        {/* Monthly Salary */}
        <div className="gratuity-input-group">
          <div className="gratuity-input-header">
            <label className="gratuity-label">Monthly Salary (Basic + DA)</label>
            <div className="gratuity-value-box">
              <span className="gratuity-symbol">₹</span>
              <input 
                type="number" 
                className="gratuity-number-input"
                value={salary}
                onChange={(e) => setSalary(Math.min(1000000, Math.max(0, parseInt(e.target.value) || 0)))}
              />
            </div>
          </div>
          <input 
            type="range" 
            className="gratuity-slider"
            min="1000"
            max="1000000"
            step="500"
            value={salary}
            style={getSliderStyle(salary, 1000, 1000000)}
            onChange={(e) => setSalary(parseInt(e.target.value))}
          />
          <div className="gratuity-range-labels">
            <span>₹1,000</span>
            <span>₹10 Lakh</span>
          </div>
        </div>

        {/* Years of Service */}
        <div className="gratuity-input-group">
          <div className="gratuity-input-header">
            <label className="gratuity-label">Years of Service</label>
            <div className="gratuity-value-box">
              <input 
                type="number" 
                className="gratuity-number-input"
                value={years}
                onChange={(e) => setYears(Math.min(50, Math.max(0, parseInt(e.target.value) || 0)))}
              />
              <span className="gratuity-symbol" style={{marginLeft: '4px'}}>Yr</span>
            </div>
          </div>
          <input 
            type="range" 
            className="gratuity-slider"
            min="1"
            max="50"
            step="1"
            value={years}
            style={getSliderStyle(years, 1, 50)}
            onChange={(e) => setYears(parseInt(e.target.value))}
          />
          <div className="gratuity-range-labels">
            <span>1 Yr</span>
            <span>50 Yr</span>
          </div>
        </div>
      </div>

      {/* Right Side: Result & Chart */}
      <div className="gratuity-result-section">
        <div className="gratuity-results-wrapper">
          <div className="gratuity-stats-container">
            <div className="gratuity-stat-item">
              <span className="gratuity-stat-label">Monthly Salary</span>
              <span className="gratuity-stat-value">{formatCurrency(salary)}</span>
            </div>
            <div className="gratuity-stat-item">
              <span className="gratuity-stat-label">Tenure</span>
              <span className="gratuity-stat-value">{years} Years</span>
            </div>
            <div className="gratuity-stat-item">
              <span className="gratuity-stat-label">Total Gratuity</span>
              <span className="gratuity-stat-value">{formatCurrency(gratuityAmount)}</span>
            </div>
          </div>

          <div className="gratuity-visual-container">
            <div className="gratuity-chart-wrapper">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={chartData}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={80}
                    paddingAngle={0}
                    dataKey="value"
                    stroke="none"
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip 
                    formatter={(value) => formatCurrency(value)}
                    contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                  />
                  <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    style={{ fontSize: '12px', fontWeight: '800', fill: '#020617' }}
                  >
                    {formatCurrency(gratuityAmount)}
                  </text>
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="gratuity-chart-legend">
              <div className="gratuity-legend-item">
                <span className="gratuity-dot"></span>
                <span>Gratuity Amount</span>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="gratuity-info-box">
          {years < 5 ? (
            <p>Note: Gratuity is usually payable after 5 years of continuous service. Current tenure is below eligibility.</p>
          ) : (
            <p>Calculation based on the formula: (Last Drawn Salary × 15 × Tenure) / 26</p>
          )}
        </div> */}
      </div>
    </div>
  );
};

export default Gratuity;
